import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { deleteWithTokenBodyAPI, getWithTokenAPI } from "../../Util/Api";
import { FaEdit, FaTrash, FaPlus, FaUser } from "react-icons/fa";
import "../../Style/Pages/Role.css"; // You can reuse or create a new CSS file
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
// import { TableSkeleton } from "../Skeleton/Skeleton";
import Swal from "sweetalert2";
import { MdDoNotDisturbAlt } from "react-icons/md";
const Resourcemanagement = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const navigate = useNavigate();
  const permission = auth.permission;

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    pages: 1,
  });

  const fetchResource = async (page = 1) => {
    try {
      setLoading(true);
      const res = await getWithTokenAPI(
        token,
        `/user/getall?limit=20&page=1&roletype=admin`,
      );

      if (res?.statusCode === 200) {
        setUsers(res?.data?.data || []);
      }

      console.log(res?.data, "Users Response");
    } catch (error) {
      console.log("Error fetching users", error);
      toast.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResource();
  }, [token]);

  const handleDeleteUser = (roleId) => {
    Swal.fire({
      title: "Delete Resource?",
      text: "Are you sure you want to delete this Resource?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#ba1b1b",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        handledelete(roleId);
      }
    });
  };
  const handledelete = async (roleId) => {
    try {
      const response = await deleteWithTokenBodyAPI(
        token,
        `/user/delete/${roleId}`,
      );

      if (response?.statusCode === 200) {
        fetchResource(); // refresh list
        toast.success("Resource deleted successfully");
      } else {
        toast.error(response?.message || "Failed to delete Resource");
      }
    } catch (error) {
      console.error("Error deleting Resource:", error);
      toast.error("Something went wrong while deleting");
    }
  };

  return (
    <div className="role-management-container">
      <div className="role-management-header">
        <h2 className="role-management-title">Resource Management</h2>
        {permission?.resouragemangement?.create && (
          <button
            className="btn-create-role"
            onClick={() => navigate("/admin/resource/create")}
          >
            <FaPlus className="create-icon" />
            Add Resource
          </button>
        )}
      </div>

      <div className="role-table-wrapper">
        <table className="role-table">
          <thead className="role-table-header">
            <tr>
              <th className="role-table-th">S No</th>
              <th className="role-table-th">User</th>
              <th className="role-table-th">Name</th>
              <th className="role-table-th">Email</th>
              <th className="role-table-th">Mobile</th>
              <th className="role-table-th">Role Type</th>
              <th className="role-table-th">Last Login</th>

              <th className="role-table-th">Actions</th>
            </tr>
          </thead>

          <tbody className="role-table-body">
            {loading ? (
              <tr>
                <td colSpan="10" className="role-table-loading">
                  {/* <TableSkeleton columns={[]} color={"#8c1007"} /> */}
                </td>
              </tr>
            ) : users.length > 0 ? (
              users.map((user, index) => (
                <tr key={user._id} className="role-table-row">
                  <td className="role-table-td">
                    {(pagination.page - 1) * pagination.limit + index + 1}
                  </td>
                  <td className="role-table-td">
                    <div className="user-avatar-cell">
                      {user.imageUrl ? (
                        <img
                          src={user.imageUrl}
                          alt={user.name}
                          className="user-avatar"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = "none";
                            e.target.parentNode.innerHTML +=
                              '<FaUser class="user-avatar-fallback" />';
                          }}
                        />
                      ) : (
                        <div className="user-avatar-fallback">
                          <FaUser size={16} />
                        </div>
                      )}
                    </div>
                  </td>
                  <td className="role-table-td role-name-cell">{user.name}</td>
                  <td className="role-table-td">{user.email || "N/A"}</td>
                  <td className="role-table-td">{user.phoneNumber || "N/A"}</td>
                  <td className="role-table-td">
                    <span className={`role-type-badge`}>
                      {user.roletype || "User"}
                    </span>
                  </td>

                  <td className="role-table-td">
                    {user.lastLogin
                      ? new Date(user.lastLogin).toLocaleDateString()
                      : "Never"}
                  </td>

                  <td className="role-table-td role-actions-cell">
                    {permission?.resouragemangement?.update ? (
                      <button
                        className="role-action-btn btn-edit"
                        onClick={() => navigate(`/admin/resource/edit/${user._id}`)}
                        title="Edit User"
                      >
                        <FaEdit className="action-icon" />
                      </button>
                    ) : (
                      <MdDoNotDisturbAlt style={{ fontSize: "20px",marginTop:"10px" }} />
                    )}

                    {permission?.resouragemangement?.delete ? (
                      <button
                        className="role-action-btn btn-delete"
                        onClick={() => handleDeleteUser(user._id)}
                        title="Delete User"
                      >
                        <FaTrash className="action-icon" />
                      </button>
                    ) : (
                      <MdDoNotDisturbAlt style={{ fontSize: "20px",marginTop:"10px" }} />
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="role-table-empty">
                  <div className="empty-state-message">
                    <FaUser size={40} className="empty-icon" />
                    <h3>No Resources Found</h3>
                    <p>Click "Add Resource" to create a new resource</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Resourcemanagement;
